<template>
  <v-container grid-list-sm fluid>
    <v-layout row wrap>
      <v-flex>
        <v-card :color="$store.state.sysBackgroundColor">
          <EncabezadoVacio :titulo="titulo" />
          <v-card-text>
            <v-form ref="form1">
              <v-layout row wrap>
                <v-flex text-right>
                  <v-chip small color="success">
                    {{ subtituloCompleto }}
                  </v-chip>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md5>
                  <v-flex v-if="esModuloVenta">
                    <SelectCliente
                      v-if="esVentaContado"
                      :model="itemActivo.Id_Cliente"
                      @seleccionarItem="seleccionarCliente"
                    />
                    <SelectCliente
                      v-else
                      :model="itemActivo.Id_Cliente"
                      :rules="[rules.requerido]"
                      @seleccionarItem="seleccionarCliente"
                    />
                  </v-flex>
                  <v-flex v-else>
                    <SelectCliente
                      :model="itemActivo.Id_Cliente"
                      :readonly="true"
                    />
                  </v-flex>
                </v-flex>
                <v-flex xs12 md6 offset-md1>
                  <SelectTipoComprobanteNumeroEmitido
                    nombreModulo="[VENTA, CAJA, EESS]"
                    :id_PuntoVenta="appId_PuntoVenta"
                    :letra="itemActivo.Letra"
                    :numero="itemActivo.Numero"
                    :rules="[rules.requerido]"
                    @seleccionarTipoComprobante="seleccionarTipoComprobante"
                    @seleccionarCondicionVenta="seleccionarCondicionVenta"
                  />
                </v-flex>
              </v-layout>
            </v-form>
            <v-layout row wrap>
              <v-flex xs12 md7>
                <Grilla
                  :columnas="grillaHeaders_Articulos"
                  :itemsDB="itemActivo.Articulos"
                  :loading="grillaLoading_Articulos"
                  :sinAccionEditar="true"
                  @borrarItem="grillaBorrarItem_Articulos"
                />
              </v-flex>
              <v-flex xs12 md4 offset-md1>
                <Grilla
                  :columnas="grillaHeaders_Pagos"
                  :itemsDB="itemActivo.Pagos"
                  :loading="grillaLoading_Pagos"
                  :sinAccionEditar="true"
                  @borrarItem="grillaBorrarItem_Pagos"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap class="pt-3">
              <v-flex xs12 md6>
                <NavBarArticulo
                  v-if="(!esRecibo || sysId_TipoIva == 'M') && !esModuloCaja"
                  :id_PuntoVenta="appId_PuntoVenta"
                  @seleccionarItem="seleccionarTecla"
                />
              </v-flex>
              <v-flex xs12 md1>
                <v-btn
                  v-if="(!esRecibo || sysId_TipoIva == 'M') && !esModuloCaja"
                  rounded
                  block
                  color="primary"
                  @click="modalArticuloEjecutarAccion('Mostrar')"
                >
                  Buscar
                  <v-icon right>shopping_cart</v-icon>
                </v-btn>
              </v-flex>
              <v-flex
                xs12
                md4
                offset-md1
                v-if="esVentaContado || esRecibo || esModuloCaja"
              >
                <v-btn
                  small
                  rounded
                  class="ma-1"
                  @click="seleccionarTipoPago($nombreTipoPago_Tarjeta)"
                >
                  Tarjeta
                  <v-icon right>credit_card</v-icon>
                </v-btn>
                <v-btn
                  small
                  rounded
                  class="ma-1"
                  @click="seleccionarTipoPago($nombreTipoPago_Cheque)"
                >
                  Cheque
                  <v-icon right>local_atm</v-icon>
                </v-btn>
                <v-btn
                  rounded
                  color="primary"
                  class="ma-1"
                  @click="seleccionarTipoPago($nombreTipoPago_Efectivo)"
                >
                  Efectivo
                  <v-icon right>attach_money</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="pt-3">
              <v-flex xs6 md1>
                <Importe
                  label="Gravado"
                  :model="itemActivo.Gravado"
                  :readonly="true"
                />
              </v-flex>
              <v-flex xs6 md1>
                <Importe
                  :label="tituloIvaBasico"
                  :model="itemActivo.IvaBasico"
                  :readonly="true"
                />
              </v-flex>
              <v-flex xs6 md1>
                <Importe
                  :label="tituloIvaDiferencial"
                  :model="itemActivo.IvaDiferencial"
                  :readonly="true"
                />
              </v-flex>
              <v-flex xs6 md1>
                <Importe
                  label="Exento"
                  :model="itemActivo.Exento"
                  :readonly="true"
                />
              </v-flex>
              <v-flex xs6 md1>
                <Importe
                  label="Impuesto Interno"
                  :model="itemActivo.ImpuestoInterno"
                  :readonly="true"
                />
              </v-flex>
              <v-flex xs6 md1>
                <Importe
                  label="Tasa A"
                  :model="itemActivo.TasaA"
                  :readonly="true"
                />
              </v-flex>
              <v-flex xs6 md1>
                <Importe
                  label="Percepción IIBB"
                  :model="itemActivo.PercepcionIb"
                  :readonly="true"
                />
              </v-flex>
              <v-flex xs12 md3 offset-md2 text-right>
                <span class="display-2 font-weight-light">
                  Total {{ itemActivo.Total | esMoneda }}
                </span>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md7 v-if="itemActivo.Archivado">
                <v-text-field
                  ref="controlFocoNota"
                  label="Notas*"
                  v-model="itemActivo.Nota"
                  :rules="[rules.requerido, rules.maximo500]"
                  @keyup.enter="archivar"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md7 v-else>
                <v-text-field
                  ref="controlFocoNota"
                  label="Notas"
                  v-model="itemActivo.Nota"
                  :rules="[rules.maximo500]"
                  @keyup.enter="finalizar"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4 offset-md1 class="text-right">
                <v-btn
                  small
                  rounded
                  class="ma-1"
                  @click="ejecutarAccion('Cancelar')"
                >
                  Cancelar
                  <v-icon right>close</v-icon>
                </v-btn>
                <v-btn small rounded class="ma-1" @click="archivar">
                  Archivar
                  <v-icon right>hourglass_top</v-icon>
                </v-btn>
                <v-btn rounded color="primary" class="ma-1" @click="finalizar">
                  Finalizar
                  <v-icon right>done</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex>
                <v-btn
                  rounded
                  small
                  v-for="item in itemsArchivados"
                  :key="item.Id_Venta"
                  class="ma-2"
                  @click="recuperar(item.Id_Venta)"
                >
                  <v-badge :color="item.Color" :content="item.Nota">
                    <small>
                      {{ item.Total | esMoneda }}
                      <small>
                        <br />
                        {{ item.Hora }}
                      </small>
                    </small>
                  </v-badge>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
          <PieCrud :loading="loading" />
        </v-card>
      </v-flex>
    </v-layout>
    <ModalArticulo
      :activo="modalArticuloActivo"
      :id_Articulo="itemActivo.Id_Articulo"
      :nombreModulo="itemActivo.NombreModulo"
      :esVentaContado="esVentaContado"
      @ejecutarAccion="modalArticuloEjecutarAccion"
    />
    <ModalTipoPagoEfectivo
      :activo="modalTipoPagoEfectivoActivo"
      :comprobante="iResumenComprobante"
      :importe="itemActivo.TotalPagoPendiente"
      @ejecutarAccion="modalTipoPagoEfectivoEjecutarAccion"
    />
    <ModalTipoPagoTarjeta
      :activo="modalTipoPagoTarjetaActivo"
      :comprobante="iResumenComprobante"
      :importe="itemActivo.TotalPagoPendiente"
      @ejecutarAccion="modalTipoPagoTarjetaEjecutarAccion"
    />
    <ModalTipoPagoCheque
      :activo="modalTipoPagoChequeActivo"
      :comprobante="iResumenComprobante"
      :importe="itemActivo.TotalPagoPendiente"
      :titular="itemActivo.RazonSocial"
      @ejecutarAccion="modalTipoPagoChequeEjecutarAccion"
    />
    <Mensaje
      :activo="mensajeActivo"
      :tipo="mensajeTipo"
      :titulo="mensajeTitulo"
      :detalle="mensajeDetalle"
      @ejecutarAccion="ejecutarAccion"
    />
    <v-snackbar
      v-model="snackActivo"
      color="success"
      :timeout="3000"
      :vertical="true"
      >Generando el comprobante...
    </v-snackbar>
  </v-container>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import moment from "moment";
import { eventBus } from "@/main";
import EncabezadoVacio from "@/components/EncabezadoVacio";
import PieCrud from "@/components/PieCrud";
import Grilla from "@/components/Grilla";
import Mensaje from "@/components/Mensaje";
import Importe from "@/components/Importe";
import SelectTipoComprobanteNumeroEmitido from "@/components/Sistema/SelectTipoComprobanteNumeroEmitido";
import SelectCliente from "@/components/Venta/SelectCliente";
import NavBarArticulo from "@/components/Stock/NavBarArticulo";
import ModalArticulo from "@/components/Stock/ModalArticulo";
import ModalTipoPagoEfectivo from "@/components/Caja/ModalTipoPagoEfectivo";
import ModalTipoPagoTarjeta from "@/components/Tarjeta/ModalTipoPagoTarjeta";
import ModalTipoPagoCheque from "@/components/Cartera/ModalTipoPagoCheque";
export default {
  name: "Venta",
  components: {
    EncabezadoVacio,
    PieCrud,
    Grilla,
    Mensaje,
    Importe,
    SelectTipoComprobanteNumeroEmitido,
    SelectCliente,
    NavBarArticulo,
    ModalArticulo,
    ModalTipoPagoEfectivo,
    ModalTipoPagoTarjeta,
    ModalTipoPagoCheque
  },
  data() {
    return {
      titulo: "Facturador",
      subtitulo: "Caja Nº ",
      itemVacio: {
        Id: 0,
        Id_Venta: 0,
        NombrePuntoVenta: "",
        NombreModulo: "",
        Id_TipoComprobante: 0,
        NombreTipoComprobante: "",
        Id_CondicionVenta: 0,
        NombreCondicionVenta: "",
        Id_Talonario: 0,
        Letra: "",
        PrefijoPuntoVenta: 0,
        Numero: "",
        Fecha: "",
        Id_Cliente: 0,
        RazonSocial: "",
        Id_TipoIva: "F",
        Cuit: "",
        Direccion: "",
        Id_TipoVenta: "",
        AlicuotaPercepcionIb: 0,
        SaldoActual: 0,
        Limite: 0,
        Id_Articulo: 0,
        Total: 0,
        Gravado: 0,
        IvaBasico: 0,
        IvaDiferencial: 0,
        Exento: 0,
        ImpuestoInterno: 0,
        TasaA: 0,
        PercepcionIb: 0,
        TotalPago: 0,
        TotalPagoPendiente: 0,
        Nota: "",
        Articulos: [],
        Pagos: [],
        Id_Caja: 0,
        FechaCaja: "",
        TurnoCaja: 0,
        NombreEmpleadoCaja: "",
        Archivado: false
      },
      itemActivo: {},
      itemsTipoPago: [],
      rules: {
        requerido: v => !!v || "Requerido",
        maximo500: v => (v || "").length <= 500 || "Máximo 500 caracteres"
      },
      grillaHeaders_Articulos: [
        {
          text: "Artículo",
          value: "Nombre",
          width: "50%",
          sortable: false
        },
        { text: "Cantidad", value: "Cantidad", sortable: false },
        { text: "Precio", value: "Precio", mask: "esMoneda", sortable: false },
        { text: "Importe", value: "Importe", mask: "esMoneda", sortable: false }
      ],
      grillaLoading_Articulos: false,
      grillaHeaders_Pagos: [
        {
          text: "Pago",
          value: "NombreTipoPago",
          width: "50%",
          sortable: false
        },
        {
          text: "Importe",
          value: "Importe",
          mask: "esMoneda",
          sortable: false
        }
      ],
      grillaLoading_Pagos: false,
      itemsArchivados: [],
      mensajeActivo: false,
      mensajeTipo: "",
      mensajeTitulo: "",
      mensajeDetalle: "",
      accion: "",
      loading: false,
      snackActivo: false,
      modalArticuloActivo: false,
      modalTipoPagoEfectivoActivo: false,
      modalTipoPagoTarjetaActivo: false,
      modalTipoPagoChequeActivo: false
    };
  },
  computed: {
    appId_PuntoVenta() {
      return this.$store.state.appId_PuntoVenta;
    },
    sysId_TipoIva() {
      return this.$store.state.sysId_TipoIva;
    },
    sysAlicuotaIvaBasico() {
      return this.$store.state.sysAlicuotaIvaBasico;
    },
    sysAlicuotaIvaDiferencial() {
      return this.$store.state.sysAlicuotaIvaDiferencial;
    },
    subtituloCompleto() {
      return this.itemActivo.Id_Caja == undefined ||
        this.itemActivo.Id_Caja == 0
        ? this.subtitulo
        : this.subtitulo +
            this.itemActivo.Id_Caja +
            " " +
            moment(this.itemActivo.FechaCaja)
              .locale("es")
              .format("DD/MM") +
            "-" +
            this.itemActivo.TurnoCaja +
            " " +
            this.itemActivo.NombreEmpleadoCaja;
    },
    tituloIvaBasico() {
      return "Iva " + this.sysAlicuotaIvaBasico + "%";
    },
    tituloIvaDiferencial() {
      return "Iva " + this.sysAlicuotaIvaDiferencial + "%";
    },
    esDistribuidor() {
      return this.itemActivo.Id_TipoVenta == this.$id_TipoVenta_Distribuidor;
    },
    esModuloVenta() {
      return this.itemActivo.NombreModulo == this.$nombreModulo_Venta;
    },
    esVentaContado() {
      return (
        this.esModuloVenta &&
        this.itemActivo.NombreCondicionVenta ==
          this.$nombreCondicionVenta_Contado
      );
    },
    esRecibo() {
      return (
        this.itemActivo.NombreTipoComprobante ==
        this.$nombreTipoComprobante_Recibo
      );
    },
    esModuloCaja() {
      return this.itemActivo.NombreModulo == this.$nombreModulo_Caja;
    },
    esModuloEeSs() {
      return this.itemActivo.NombreModulo == this.$nombreModulo_EeSs;
    },
    iResumenComprobante() {
      return (
        this.itemActivo.NombreTipoComprobante +
        " Nº " +
        this.itemActivo.Numero +
        " " +
        this.itemActivo.NombreCondicionVenta +
        (this.itemActivo.RazonSocial
          ? " a " + this.itemActivo.RazonSocial
          : " a Consumidor Final")
      );
    }
  },
  mounted() {
    this.ejecutarAccion("Inicializar");
  },
  methods: {
    ejecutarAccion(accion) {
      this.accion = accion;
      switch (accion) {
        case "Guardar":
          this.mostrarMensaje(
            true,
            "ConfirmacionGuardar",
            "¿Quiere guardar el comprobante?",
            this.iResumenComprobante
          );
          break;
        case "AceptarConfirmacionGuardar":
        case "Archivar":
          this.guardarItem(this.itemActivo);
          break;
        case "AceptarConfirmacionBorrarArchivado":
          this.borrarArchivado(this.itemActivo);
          break;
        case "CancelarConfirmacionGuardar":
        case "CancelarConfirmacionBorrarArchivado":
        case "CancelarAviso":
          this.mostrarMensaje(false);
          break;
        case "CancelarError":
          this.mostrarMensaje(false);
          this.ejecutarAccion("Inicializar");
          break;
        case "Inicializar":
          this.inicializar();
          break;
        case "Cancelar":
          this.cancelar();
          break;
      }
    },
    inicializar() {
      this.itemActivo = Object.assign({}, this.itemVacio);
      this.itemActivo.Articulos = [];
      this.itemActivo.Pagos = [];
      var promesa1 = new Promise(function(resolve) {
        eventBus.$emit("inicializarSelectCliente");
        resolve();
      });
      var promesa2 = new Promise(function(resolve) {
        eventBus.$emit("inicializarSelectTipoComprobanteNumeroEmitido");
        resolve();
      });
      promesa1.then(() => {
        promesa2.then(() => {
          this.buscarArchivados();
          this.modalArticuloEjecutarAccion("Mostrar");
          // this.modalArticuloEjecutarAccion("Mostrar"); comentado en TL3.
        });
      });
    },
    cancelar() {
      if (this.itemActivo.Id_Venta) {
        this.mostrarMensaje(
          true,
          "ConfirmacionBorrarArchivado",
          "¿Quiere borrar el comprobante?",
          this.iResumenComprobante
        );
      } else this.inicializar();
    },
    seleccionarCliente(item) {
      this.itemActivo.Id_Cliente = item.Id_Cliente;
      this.itemActivo.RazonSocial = item.RazonSocial;
      this.itemActivo.Id_TipoIva = item.Id_TipoIva;
      this.itemActivo.Cuit = item.Cuit;
      this.itemActivo.Direccion = item.Direccion;
      this.itemActivo.Id_TipoVenta = item.Id_TipoVenta;
      this.itemActivo.AlicuotaPercepcionIb = item.AlicuotaPercepcionIb;
      this.itemActivo.SaldoActual = item.SaldoActual;
      this.itemActivo.Limite = item.Limite;
      this.seleccionarLetra();
    },
    seleccionarLetra(letra) {
      if (letra == null || "ABC".includes(this.itemActivo.Letra)) {
        if (this.sysId_TipoIva == "I")
          this.itemActivo.Letra = this.itemActivo.Id_TipoIva == "I" ? "A" : "B";
        else this.itemActivo.Letra = "C";
      } else this.itemActivo.Letra = letra;
    },
    seleccionarTipoComprobante(item) {
      if (item.NombreModulo != null) {
        this.itemActivo.NombrePuntoVenta = item.NombrePuntoVenta;
        this.itemActivo.NombreModulo = item.NombreModulo;
        this.itemActivo.Id_TipoComprobante = item.Id_TipoComprobante;
        this.itemActivo.NombreTipoComprobante = item.NombreTipoComprobante;
        this.itemActivo.Id_Talonario = item.Id_Talonario;
        this.itemActivo.PrefijoPuntoVenta = item.PrefijoPuntoVenta;
        this.itemActivo.Numero = item.NumeroActual;
        this.itemActivo.Fecha = item.Fecha;
        this.itemActivo.Id_Caja = item.Id_Caja;
        this.itemActivo.FechaCaja = item.FechaCaja;
        this.itemActivo.TurnoCaja = item.TurnoCaja;
        this.itemActivo.NombreEmpleadoCaja = item.NombreEmpleadoCaja;
        this.seleccionarLetra(item.Letra);
        this.cargarTiposPago();
      }
    },
    cargarTiposPago() {
      this.itemsTipoPago = [];
      this.grillaLoading_Pagos = true;
      HttpHelper.get("TipoPago/ListarPorModulo", {
        nombreModulo: this.itemActivo.NombreModulo
      })
        .then(response => {
          this.itemsTipoPago = response.data;
          this.grillaLoading_Pagos = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    seleccionarCondicionVenta(item) {
      this.itemActivo.Id_CondicionVenta = item.Id_CondicionVenta;
      this.itemActivo.NombreCondicionVenta = item.NombreCondicionVenta;
      if (!this.esVentaContado) {
        this.itemActivo.TotalPago = 0;
        this.itemActivo.Pagos = [];
      }
    },
    buscarArchivados() {
      this.itemsArchivados = [];
      this.loading = true;
      HttpHelper.get("Venta/BuscarArchivados", {
        id_PuntoVenta: this.appId_PuntoVenta
      })
        .then(response => {
          this.itemsArchivados = response.data;
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    grillaBorrarItem_Articulos(item) {
      var ind = this.itemActivo.Articulos.findIndex(
        x => x.Id_Articulo == item.Id_Articulo
      );
      this.itemActivo.Articulos.splice(ind, 1);
      this.calcularTotal();
    },
    seleccionarTecla(item) {
      this.modalArticuloEjecutarAccion("Mostrar", item);
    },
    modalArticuloEjecutarAccion(accion, item) {
      switch (accion) {
        case "Mostrar":
          this.itemActivo.Id_Articulo = item ? item.Id_Articulo : 0;
          this.modalArticuloActivo = true;
          break;
        case "Aceptar":
          this.agregarArticulo(item);
          this.modalArticuloActivo = false;
          break;
        case "Cerrar":
          this.modalArticuloActivo = false;
          setTimeout(() => {
            this.$refs.controlFocoNota.focus();
          }, 100);
          break;
      }
    },
    agregarArticulo(item) {
      this.grillaLoading_Articulos = true;
      if (item.Importe > 0) {
        var gravado = 0;
        var ivaBasico = 0;
        var ivaDiferencial = 0;
        var exento = 0;
        var impuestoInterno = 0;
        var tasaA = 0;
        var percepcionIb = 0;
        impuestoInterno = item.Cantidad * item.ImpuestoInternoArticulo;
        tasaA = item.Cantidad * item.TasaAArticulo;
        gravado = item.Importe - impuestoInterno - tasaA;
        if (item.Id_TipoIvaArticulo == this.$id_TipoIvaArticulo_Gravado) {
          gravado = gravado / (1 + this.sysAlicuotaIvaBasico / 100);
          ivaBasico = gravado * (this.sysAlicuotaIvaBasico / 100);
        } else {
          if (item.Id_TipoIvaArticulo == this.$id_TipoIvaArticulo_Diferencial) {
            gravado = gravado / (1 + this.sysAlicuotaIvaDiferencial / 100);
            ivaDiferencial = gravado * (this.sysAlicuotaIvaDiferencial / 100);
          } else {
            exento = gravado;
            gravado = 0;
          }
        }
        if (this.esDistribuidor)
          percepcionIb = gravado * (item.AlicuotaPercepcionIb / 100);
        this.itemActivo.Articulos.push({
          Id_Articulo: item.Id_Articulo,
          Nombre: item.NombreArticulo,
          Cantidad: item.Cantidad,
          Precio: item.Precio,
          Importe: item.Importe,
          Gravado: gravado,
          IvaBasico: ivaBasico,
          IvaDiferencial: ivaDiferencial,
          Exento: exento,
          ImpuestoInterno: impuestoInterno,
          TasaA: tasaA,
          PercepcionIb: percepcionIb
        });
        this.calcularTotal();
        setTimeout(() => {
          this.$refs.controlFocoNota.focus();
          // this.modalArticuloEjecutarAccion("Mostrar"); comentado en TL3.
        }, 100);
      }
      this.grillaLoading_Articulos = false;
    },
    calcularTotal() {
      this.itemActivo.Gravado = this.itemActivo.IvaBasico = this.itemActivo.IvaDiferencial = this.itemActivo.Exento = this.itemActivo.ImpuestoInterno = this.itemActivo.Total = this.itemActivo.TasaA = this.itemActivo.PercepcionIb = 0;
      this.itemActivo.Articulos.forEach(item => {
        this.itemActivo.Gravado += item.Gravado;
        this.itemActivo.IvaBasico += item.IvaBasico;
        this.itemActivo.IvaDiferencial += item.IvaDiferencial;
        this.itemActivo.Exento += item.Exento;
        this.itemActivo.ImpuestoInterno += item.ImpuestoInterno;
        this.itemActivo.TasaA += item.TasaA;
        this.itemActivo.PercepcionIb += item.PercepcionIb;
        this.itemActivo.Total += this.itemActivo.PercepcionIb;
        this.itemActivo.Total += item.Importe;
      });
      if (this.esVentaContado || this.esRecibo) this.sugerirPagoEfectivo();
      else this.controlarLimite();
    },
    sugerirPagoEfectivo() {
      this.itemActivo.Pagos = [];
      this.agregarPago({
        NombreTipoPago: this.$nombreTipoPago_Efectivo,
        Importe: this.itemActivo.Total
      });
    },
    controlarLimite() {
      if (
        this.esModuloVenta &&
        !this.esRecibo &&
        this.itemActivo.Total >
          this.itemActivo.Limite - this.itemActivo.SaldoActual
      ) {
        this.mostrarMensaje(
          true,
          "Aviso",
          "Límite Superado",
          "El cliente supera su límite en CTA.CTE."
        );
      }
    },
    grillaBorrarItem_Pagos(item) {
      var ind = this.itemActivo.Pagos.findIndex(
        x => x.Id_TipoPago == item.Id_TipoPago
      );
      this.itemActivo.Pagos.splice(ind, 1);
      this.calcularTotalPago();
    },
    seleccionarTipoPago(nombre) {
      this.calcularTotalPago();
      if (
        this.itemActivo.TotalPagoPendiente > 0 ||
        this.esRecibo ||
        this.esModuloCaja
      ) {
        switch (nombre) {
          case this.$nombreTipoPago_Tarjeta:
            this.modalTipoPagoTarjetaEjecutarAccion("Mostrar");
            break;
          case this.$nombreTipoPago_Cheque:
            this.modalTipoPagoChequeEjecutarAccion("Mostrar");
            break;
          default:
            this.modalTipoPagoEfectivoEjecutarAccion("Mostrar");
            break;
        }
      }
    },
    modalTipoPagoEfectivoEjecutarAccion(accion, item) {
      switch (accion) {
        case "Mostrar":
          this.modalTipoPagoEfectivoActivo = true;
          break;
        case "Aceptar":
          item.NombreTipoPago = this.$nombreTipoPago_Efectivo;
          this.agregarPago(item);
          this.modalTipoPagoEfectivoActivo = false;
          break;
        case "Cerrar":
          this.modalTipoPagoEfectivoActivo = false;
          break;
      }
    },
    modalTipoPagoTarjetaEjecutarAccion(accion, item) {
      switch (accion) {
        case "Mostrar":
          this.modalTipoPagoTarjetaActivo = true;
          break;
        case "Aceptar":
          item.NombreTipoPago = this.$nombreTipoPago_Tarjeta;
          this.agregarPago(item);
          this.modalTipoPagoTarjetaActivo = false;
          break;
        case "Cerrar":
          this.modalTipoPagoTarjetaActivo = false;
          break;
      }
    },
    modalTipoPagoChequeEjecutarAccion(accion, item) {
      switch (accion) {
        case "Mostrar":
          this.modalTipoPagoChequeActivo = true;
          break;
        case "Aceptar":
          item.NombreTipoPago = this.$nombreTipoPago_Cheque;
          this.agregarPago(item);
          this.modalTipoPagoChequeActivo = false;
          break;
        case "Cerrar":
          this.modalTipoPagoChequeActivo = false;
          break;
      }
    },
    agregarPago(item) {
      this.grillaLoading_Pagos = true;
      if (item.Importe > 0) {
        var ind = this.itemsTipoPago.findIndex(
          x => x.Nombre == item.NombreTipoPago
        );
        item.Id_TipoPago = this.itemsTipoPago[ind].Id_TipoPago;
        switch (item.NombreTipoPago) {
          case this.$nombreTipoPago_Tarjeta:
            this.itemActivo.Pagos.push({
              Id_TipoPago: item.Id_TipoPago,
              NombreTipoPago: item.NombreTipoPago,
              Importe: item.Importe,
              Id_Tarjeta: item.Id_Tarjeta,
              Lote: item.Lote,
              NumeroCupon: item.NumeroCupon,
              Autorizacion: item.Autorizacion
            });
            break;
          case this.$nombreTipoPago_Cheque:
            this.itemActivo.Pagos.push({
              Id_TipoPago: item.Id_TipoPago,
              NombreTipoPago: item.NombreTipoPago,
              Importe: item.Importe,
              Id_Banco: item.Id_Banco,
              NumeroChequeTercero: item.NumeroChequeTercero,
              FechaPago: item.FechaPago,
              Titular: item.Titular
            });
            break;
          default:
            this.itemActivo.Pagos.push({
              Id_TipoPago: item.Id_TipoPago,
              NombreTipoPago: item.NombreTipoPago,
              Importe: item.Importe
            });
        }
        this.calcularTotalPago();
      }
      this.grillaLoading_Pagos = false;
    },
    calcularTotalPago() {
      this.itemActivo.TotalPago = 0;
      if (this.itemActivo.Pagos) {
        this.itemActivo.TotalPago = this.itemActivo.Pagos.map(
          item => item.Importe
        ).reduce((a, b) => a + b, 0);
        if (this.esRecibo || this.esModuloCaja)
          this.itemActivo.Total = this.itemActivo.TotalPago;
      }
      this.itemActivo.TotalPagoPendiente =
        this.itemActivo.Total - this.itemActivo.TotalPago;
    },
    validarPago() {
      let ok =
        this.itemActivo.TotalPago >= this.itemActivo.Total ||
        !this.esVentaContado;
      if (!ok)
        this.mostrarMensaje(
          true,
          "Aviso",
          null,
          "Debe completar la forma de pago."
        );
      return ok;
    },
    finalizar() {
      if (
        this.$refs.form1.validate() &&
        this.itemActivo.Total > 0 &&
        this.validarPago()
      ) {
        this.itemActivo.Archivado = false;
        this.ejecutarAccion("Guardar");
      }
    },
    guardarItem(item) {
      this.snackActivo = true;
      if (this.esRecibo && this.sysId_TipoIva != "M")
        this.itemActivo.Articulos = [];
      if (!this.esVentaContado && !this.esRecibo) this.itemActivo.Pagos = [];
      this.itemActivo.EstadoFiscal = this.itemActivo.Archivado
        ? "ARCHIVADO"
        : null;
      if (this.esModuloCaja) this.guardarVale(item);
      else {
        if (item.Id_Venta) this.borrarArchivado(item);
        this.guardarVenta(item);
      }
      setTimeout(() => {
        this.snackActivo = false;
      }, 2000);
    },
    guardarVenta(item) {
      item.Id_Venta = 0;
      HttpHelper.post("Venta", item)
        .then(response => {
          this.itemActivo.Id = response.data;
          if (this.itemActivo.Archivado) this.mostrarItemArchivado();
          this.ejecutarAccion("Inicializar");
          this.mostrarMensaje(false);
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    guardarVale(item) {
      HttpHelper.post("Vale", item)
        .then(() => {
          this.ejecutarAccion("Inicializar");
          this.mostrarMensaje(false);
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    mostrarItemArchivado() {
      this.itemsArchivados.push({
        Id: this.itemActivo.Id,
        Nota: this.itemActivo.Nota,
        Hora: this.itemActivo.Fecha.toString().substr(11, 5),
        Orden: this.itemActivo.Id.toString().substr(2, 3),
        Color: "red"
      });
    },
    archivar() {
      if (
        this.esModuloVenta &&
        this.$refs.form1.validate() &&
        this.itemActivo.Total > 0
      ) {
        this.itemActivo.Archivado = true;
        if (this.itemActivo.Nota == "") {
          setTimeout(() => {
            this.$refs.controlFocoNota.focus();
          }, 100);
        } else this.ejecutarAccion("Archivar");
      }
    },
    recuperar(id) {
      this.loading = this.grillaLoading_Articulos = this.grillaLoading_Pagos = true;
      HttpHelper.get("Venta/Buscar", {
        id_Venta: id
      })
        .then(response => {
          this.itemActivo.Id_Venta = id;
          this.itemActivo.Id_Cliente = response.data.Id_Cliente;
          this.itemActivo.Nota = response.data.Nota;
          this.itemActivo.Gravado = response.data.Gravado;
          this.itemActivo.IvaBasico = response.data.IvaBasico;
          this.itemActivo.IvaDiferencial = response.data.IvaDiferencial;
          this.itemActivo.Exento = response.data.Exento;
          this.itemActivo.ImpuestoInterno = response.data.ImpuestoInterno;
          this.itemActivo.TasaA = response.data.TasaA;
          this.itemActivo.PercepcionIb = response.data.PercepcionIb;
          this.itemActivo.Total = response.data.Total;
          this.itemActivo.Articulos = response.data.Articulos;
          this.loading = this.grillaLoading_Articulos = this.grillaLoading_Pagos = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    borrarArchivado(item) {
      HttpHelper.delete("Venta", { data: item })
        .then(() => {
          this.ejecutarAccion("Inicializar");
          this.mostrarMensaje(false);
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    mostrarError(error) {
      var detalle;
      detalle =
        error.response === undefined
          ? error
          : error.response.data.ExceptionMessage;
      this.mostrarMensaje(true, "Error", null, detalle);
    },
    mostrarMensaje(activo, tipo, titulo, detalle) {
      if (activo) {
        this.mensajeTipo = tipo;
        this.mensajeTitulo = titulo;
        this.mensajeDetalle = detalle;
      }
      this.mensajeActivo = activo;
    }
  }
};
</script>
